import React, {Suspense} from 'react';
import './index.css';
import {App} from './App';
import {hydrate, render} from 'react-dom';
import {Provider} from "react-redux";
import {history, store} from "./_helpers";
import {ThemeProvider} from "@material-ui/styles";
import theme from "./styles/theme";
import {ToastProvider} from "react-toast-notifications";
import {Router} from "react-router-dom";
import './i18n.js'
import {register} from 'razzle-plugin-workbox/service-worker';

const Loader = () => {
  return <div/>;
};

// flag to turn https redirect on/off based on url

const renderMethod = module.hot ? render : hydrate;
renderMethod(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <Router history={history}>
          <Suspense fallback={<Loader/>}>
              <App/>
          </Suspense>
        </Router>
      </ToastProvider>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept('./App', () => {
    hydrate(
      <Provider store={store}>
        <App />
      </Provider>,
      document.getElementById('root')
    );
  });
}

// service worker register
register();